import { SyncFn } from './sync-coordinator';

/**
 * No-op sync function for pairs that should not sync
 * (e.g., FreeView or Map as source).
 */
export const syncNoOp: SyncFn = async () => {
  return;
};
